"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPageRowsLoadStatus = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledPageRowsLoadStatus = styled_components_1.default.div `
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  flex-shrink: 0;
  white-space: nowrap;
  cursor: pointer;

  & .MuiTypography-root {
    color: ${ui_components_1.baseColors.primaryBlueAccent500};
  }
`;
